<rsswa-section1
  id="section1"
  [rsswa]="rsswa"
  [status]="status"
  #section1
></rsswa-section1>
<div
  class="mt-3"
  *ngIf="
    rsswa?.id &&
    rsswa?.status != formStatusEnum.New &&
    rsswa?.status != formStatusEnum.Draft
  "
>
  <rsswa-section3 id="section3" [rsswa]="rsswa" #section3></rsswa-section3>
  <rsswa-section4 id="section4" [rsswa]="rsswa" #section4></rsswa-section4>
  <div class="container-fluid">
    <worker-verification-table
      [currentDocument]="rsswa"
      [disabled]="testingCompleteSigned"
      [privilegeToSign]="privilegeEnum.Worker"
      *ngIf="
        rsswa &&
        rsswa?.status !== formStatusEnum.New &&
        rsswa?.status != formStatusEnum.Draft
      "
    ></worker-verification-table>
    <rss-functional-test-list
      *ngIf="rsswa?.functionalTest"
      #rssFunctionalTestSection
      [rsswa]="rsswa"
      id="rssFunctionalTestSection"
      [showAmendment]="status.isViewingAmendment ?? false"
    ></rss-functional-test-list>
  </div>

  <rsswa-section5 [rsswa]="rsswa" id="section5" #section5></rsswa-section5>
  <rsswa-section6 id="section6" [rsswa]="rsswa" #section6></rsswa-section6>
  <div class="container-fluid mt-4">
    <comments-and-attachments
      id="section8"
      #section8
      [currentDocument]="rsswa"
      headerClass="h5"
    ></comments-and-attachments>
  </div>
</div>
